$(function () {
  $('[data-toggle="popover"]').popover();
});

$(function() {
	
	async function update_db(path,class_name,id,attr_name,attr_value) {
		const address	= "/" + path	;
		const params	= JSON.stringify(
									{	[class_name]: 	{ 
				    										[attr_name]	:	attr_value	,
					    								}	
									}
								);

		const response 	= await fetch(address, {
												        method: 	"PUT",
												        headers: 	{ 
												        					"Content-Type"	: "application/json" ,
												        					"Accept"		: "application/json"  
												        			},
												        body: 		params
													}
									);
									
		$("#" + id).addClass("text-success");
	};
	
	$(".js_update").on("change", function () {
		id 			= 	this.id							;
		attr_name	=	this.name						;
		attr_value	=	this.value						;

		class_name	= 	$(this).attr("class_name")		;
		path		=	$(this).attr("path")		;
		update_db(path,class_name,id,attr_name,attr_value);
	});
	 
});

$(function() {
    // WILL LOAD AUTOMITICALLY AFTER PAGE LOAD
    setTimeout(function() {
        $(".hide_2").hide('blind', {}, 500);
    }, 2000);
});

$(function () {
	// CLINK auto_click
    var el = $('#auto_click');

    // execute only if element exists
    if (!el.length) return;

    setTimeout(function () {
        var href = el.attr('href');

        if (href) {
            // link_to (<a>)
            window.location.href = href;
        } else {
            // button / input
            el.trigger('click');
        }
    }, 3000);
});


$(function() {
	$(".date_picker").datepicker({
		dateFormat: "yy-mm-dd"
	});
});

  $(function() {
    $( ".datepicker_month_year" ).datepicker({
      changeMonth: true,
      changeYear: true,
	  dateFormat: "yy-mm-dd"
    });
  });
  
$(function () {
    $('.boot_select').selectpicker();
});

$(function() {
	$("#add_spare_transaction").focus(function(){
	  	$("#add_spare_transaction_message").text("START SCAN OF SPARE PARTS");
	});
	
	$("#add_spare_transaction").focusout(function(){
	  	$("#add_spare_transaction_message").text("SELECT TEXT BOX BELOW BEOFRE SCANNING.");
	});
	
});

$(function() {
	$(".navbar-toggler").click(function(){
	  $(".link_div").toggle();
	});
});

$(function() {
	$(".js_required").prop('required',true);
});

window.notif =	function(success) {
					if(success == true)
						add_class = "bg-success"			;
					else if(success == false)
						add_class = "bg-danger"			;
					else if(success == "REPEAT-SCAN")
						add_class = "bg-warning"		;
					else
						add_class = "alert-danger"		;
					
					setTimeout(function (){document.getElementById("notif").classList.add(add_class)	;}, 100)	;
					setTimeout(function (){document.getElementById("notif").classList.remove(add_class)	;}, 2000)	;
					
					if(success == true)
						sound_notify_success()			;
					else if(success == false)
						sound_notify_failure()			;
					else if(success == "REPEAT-SCAN")
						sound_notify_failure()		;
					else
						sound_notify_failure()		;
};

$(function() {
	$( ".notify_table_row" ).click(function() {
		notify_id  = $(this).attr("notify_id")	;
		notify_table_row(notify_id)	;
	});
});

$(function() {
	 $('.bulk_check_exec').change(function() {
        // Check if the toggle-all checkbox is checked
        var isChecked = $(this).is(':checked');
        
        // Set the state of all other checkboxes to match the toggle-all checkbox
        $('.bulk_check').prop('checked', isChecked);
    });
});

$(function() {
	 $('#print_page').click(function() {
	 		window.print();
    });
    $(document).ready(function () {
		print_request = window.location.href.indexOf("print=true") != -1 ;
		if(print_request)
			window.print();
	});
});

$(function() {
    $('#font_size').on('change', function() {
        var sizeValue = parseInt($(this).val(), 10);

        // Map number to font-size in px (you can adjust multiplier)
        var fontSize = sizeValue;

        $('.adj_height_widht').css('font-size', fontSize + 'px');
    });
});

window.notify_table_row = function(table_row_id) {
							temp_class = "table-light"	;
							table_row = document.getElementById(table_row_id)	;
							
							table = table_row.parentNode;
							table = table.insertBefore(table_row, table.firstChild);
							
							current_classes = Array.from(table_row.classList)	;
							
							setTimeout(function (){table_row.classList.add(temp_class)		;}, 100)	;
							setTimeout(function (){table_row.classList.remove(temp_class)	;}, 1000)	;
							
};

window.notify_text = function(text) {
					setTimeout(function (){$("#notif_text").text(text)	;}, 100)	;
					setTimeout(function (){$("#notif_text").text("")	;}, 4000)	;
};

window.show_alert =	function(success) {
					alert("ALERT");
};

window.sound_notify_success =	function() {
		audio_path = "/assets/success-1.mp3" ;
        var audio = new Audio(audio_path); 
        audio.play();
};
   
window.sound_notify_failure =	function() {
		audio_path = "/assets/error-1.mp3"	;
        var audio = new Audio(audio_path); 
        audio.play();
};

window.sound_location =	function() {
		audio_path = "/assets/container.wav"	;
        var audio = new Audio(audio_path); 
        audio.play();
};

